/* eslint-disable no-shadow */
import { Grid } from '@material-ui/core'
import Button from '@material-ui/core/Button'
import withStyles from '@material-ui/core/styles/withStyles'
import Typography from '@material-ui/core/Typography'
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link, Route } from 'react-router-dom'
import { bindActionCreators } from 'redux'

import styles from '../../../resources/theme/global'
import { renderRoute } from '../../../util/utils'
import { fetchMeasureType } from '../MeasureTypeActions'
import { getMeasureTypeListData } from '../MeasureTypeReducer'

import Edit from './Edit'
import Filter from './Filter'
import List from './List'
import New from './New'

class MeasureType extends Component {
  componentDidMount() {
    const { fetchMeasureType } = this.props
    fetchMeasureType()
  }

  render() {
    const { classes, permissions } = this.props

    return (
      <>
        <Grid
          container
          className={classes.pageHead}
          spacing={1}
          alignItems="center"
        >
          <Grid item xs>
            <Typography variant="h4" color="secondary">
              Unidades de medida
            </Typography>
          </Grid>
          <Grid item>
            <Filter classes={classes} />
          </Grid>
          <Grid item>
            {renderRoute(['create-measure-types'], permissions) && (
              <Button
                color="primary"
                variant="contained"
                component={Link}
                to="/measure-type/new"
              >
                <AddCircleOutlineIcon className={classes.btnIcon} /> Cadastrar
              </Button>
            )}
          </Grid>
        </Grid>

        {renderRoute(['create-measure-types'], permissions) && (
          <Route path="/measure-type/new" component={New} />
        )}
        {renderRoute(['update-measure-types'], permissions) && (
          <Route path="/measure-type/:id/edit" component={Edit} />
        )}

        <List {...this.props} />
      </>
    )
  }
}

const mapStateToProps = state => ({
  ...getMeasureTypeListData(state),
  permissions: state.auth.permissions || [],
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      fetchMeasureType,
    },
    dispatch
  )
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(MeasureType))
